import { BackendResponse } from "../BackendResponse";
import { withNextApi } from "../nextApiHelpers";

export interface GetPositionWishesFromCandidateObjResponse
  extends BackendResponse {
  items: CandidatePosition[];
}

export const getPositionWishesFromCandidateObj =
  withNextApi<GetPositionWishesFromCandidateObjResponse>(
    "/cvp/CvpGetPositionWishesFromCandidateObj"
  );

export interface CandidatePosition {
  id: number;
  name: string;
  category: string;
  level: number;
}
